import script from "./WorkflowAggregatesTagSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAggregatesTagSelector.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAggregatesTagSelector.vue?vue&type=style&index=0&id=4e80c17a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e80c17a"]])

export default __exports__